import { CommonModule } from '@angular/common';
import { Component, Input, NgModule, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-toolbar-button',
  templateUrl: './toolbar-button.component.html',
  styleUrls: ['./toolbar-button.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ToolbarButtonComponent implements OnInit {

  @Input() buttonClass: string | string[] | Set<string> | { [klass: string]: any; };
  @Input() title: string;

  constructor() { }

  ngOnInit() {
  }

}
@NgModule({
  declarations: [ToolbarButtonComponent],
  imports: [CommonModule],
  exports: [ToolbarButtonComponent]
})
export class ToolbarButtonModule { }
